import { ImageSlider as H } from "./index216.mjs";
import { Rates as K } from "./index215.mjs";
import { RoomDetailsTags as M } from "./index214.mjs";
import { RoomAmenities as W } from "./index220.mjs";
import { RoomTitle as k } from "./index217.mjs";
import e, { useState as w, useEffect as d } from "react";
import G from "./index221.mjs";
import { useAtomValue as Y } from "jotai";
import { selectedRateAtom as j } from "./index60.mjs";
import { TermsAndConditions as q } from "./index108.mjs";
import { Description as B } from "./index209.mjs";
import { Header as J } from "./index89.mjs";
import L from "./index79.mjs";
import { useCartManager as Q } from "./index138.mjs";
import { track as U } from "./index9.mjs";
import { TRACK_EVENT_TYPE as X, TRACK_EVENT as Z } from "./index10.mjs";
import { useHotelConfig as $ } from "./index93.mjs";
import { getSubscriptionPlanRoot as ee } from "./index14.mjs";
const Te = ({
  id: o,
  images: E,
  name: m,
  tags: _,
  description: u,
  rates: i,
  currency: g,
  noOfRooms: R,
  maxOccupancy: T,
  maxChildren: A,
  maxAdults: I,
  merchantId: y,
  motherId: h,
  motherName: C,
  isExpanded: P,
  cityTaxIncluded: s,
  onBack: b,
  onClose: N,
  searchInputs: S
}) => {
  const r = Y(j), [V, O] = w([]), { addOrRemoveFromCart: v } = Q(), { hotelId: a, propertySize: l, propertyType: p, subscriptionPlan: c } = $();
  d(() => {
    r || U(Z.VIEW, X.VIEW_ROOM_PAGE, {
      hotel_id: a,
      property_type: p,
      property_size: l,
      subscription_plan: ee(c),
      total_results_shown: i.length
    });
  }, [
    a,
    l,
    p,
    i.length,
    r,
    c
  ]), d(() => {
    L.getRoomAmenities(o).then((n) => {
      O(n.amenities);
    });
  }, [o]);
  const x = (n, t, f, z) => {
    const D = {
      roomId: o,
      roomName: m,
      maxOccupancy: T,
      maxChildren: A,
      maxAdults: I,
      cityTaxIncluded: !!s
    }, F = {
      pricingTypeId: f || t.id,
      pricingTypeName: t.name,
      promoCodeAdded: z || !1,
      totalPrice: t.total_price,
      insuranceEligible: t.sales_term.insurance_eligible,
      ...f && { promotionId: t.id }
    };
    v(parseInt(n), D, F);
  };
  return r ? /* @__PURE__ */ e.createElement(q, { salesTerms: r.sales_term }) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    J,
    {
      searchInputs: S,
      title: m,
      onClose: N,
      onBack: b
    }
  ), /* @__PURE__ */ e.createElement("div", { className: G.container, "data-testid": "selected-room" }, /* @__PURE__ */ e.createElement(H, { images: E, source: "results_page" }), /* @__PURE__ */ e.createElement(k, { name: m }), /* @__PURE__ */ e.createElement(M, { tags: _ }), /* @__PURE__ */ e.createElement(B, { text: u }), /* @__PURE__ */ e.createElement(W, { amenities: V, isExpanded: P }), /* @__PURE__ */ e.createElement(
    K,
    {
      rates: i,
      currency: g,
      roomId: o,
      merchantId: y,
      motherId: h,
      motherName: C,
      noOfRooms: R,
      onRateSelect: x,
      cityTaxIncluded: s
    }
  )));
};
export {
  Te as RoomPage
};
